import {
  ADMIN_QA_CALLING_FROM_FUNCTION,
  TRANSACTIONAL_EMAIL_FIELD_DEFS,
  TRANSACTIONAL_EMAIL_TEMPLATES,
} from './constants'
import { getQaDefaultFieldValuesForTemplate } from './qa-field-fixtures'

export interface MemberContext {
  email: string
  userUuid: string
}

export function getDefaultTemplateId (): string {
  return TRANSACTIONAL_EMAIL_TEMPLATES[0]?.id || 'PASSWORD_RESET'
}

export function buildDefaultFieldValues (
  templateId: string,
  member: MemberContext,
): Record<string, string> {
  const base = getQaDefaultFieldValuesForTemplate(templateId, member.email)
  const defs = TRANSACTIONAL_EMAIL_FIELD_DEFS[templateId] || []
  const merged: Record<string, string> = {}
  defs.forEach((def) => {
    merged[def.key] = base[def.key] ?? ''
  })
  return merged
}

export { ADMIN_QA_CALLING_FROM_FUNCTION }
